import { Button } from '@progress/kendo-react-buttons';
import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';
import CustomModal from 'commons/modal/CustomModal';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { dateTextFormat } from 'commons/models/dates';
import { FormTextAreaWithButton, FormTextArea } from 'commons/forms/form';
import { useLocation, useNavigate } from 'react-router-dom';
import LoaderContainer from 'commons/container/LoaderContainer';
import _ from 'lodash';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import { completee, enAttente, enCours } from 'constants/taskStatus';
import { useAddTachePlanifMutation, useAddTacheUsagerMutation, useGetDocMetaQuery, useGetTachesPlanifQuery, useGetTachesQuery, useGetTachesUsagerQuery, useRemoveTachePlanifMutation, useUpdateTachePlanifMutation, useUpdateTacheUsagerMutation } from '../../../redux/api/cache';
import { fetchDocument } from '../../../redux/api/document';
import { useAppSelector } from '../../../redux/store';

export default function ModifyFileModal(props) {
  const [idTache, setIdTache] = useState(-1);
  const [rowToEdit, setRowToEdit] = useState(undefined);
  const [currentTaskPlanif, setCurrentTaskPlanif] = useState([]);
  const [documentData, setDocumentData] = useState(undefined);
  const [objectURL, setObjectURL] = useState(undefined);
  const [base64PDF, setBase64PDF] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  // @ts-ignore
  const user = useAppSelector(state => state.appState.user);
  const { data, isLoading } = useGetDocMetaQuery(props.selectedDocRow.rid);
  const isAcheteur = user !== (data?.data?.find(d => d.docm_descr === 'usr_cd').docm_val);
  const { data: task = {} } = useGetTachesQuery({ usr_cd: user, filtre: 'usager' }, { skip: !user });
  const { data: taskUser } = useGetTachesUsagerQuery({ tac_id: idTache }, { skip: idTache === -1 });
  const { data: taskCurrentUser = {} } = useGetTachesUsagerQuery({ tac_id: idTache, usr_cd: user }, { skip: idTache === -1 || !user });
  const { data: taskPlanif = {} } = useGetTachesPlanifQuery({ tac_id: idTache, usr_cd: isAcheteur ? user : '' }, { skip: idTache === -1 });
  const [addTachePlanif] = useAddTachePlanifMutation();
  const [addTacheUsager] = useAddTacheUsagerMutation();
  const [updateTachePlanif] = useUpdateTachePlanifMutation();
  const [removeTachePlanif] = useRemoveTachePlanifMutation();
  const [updateTacheUsager] = useUpdateTacheUsagerMutation();

  useEffect(() => {
    const fetchDocuments = async () => {
      let result = await fetchDocument(`${props.selectedDocRow.path}${props.selectedDocRow.nom}`);
      setObjectURL(new Blob([result.data], { type: result.headers['content-type'] }));
      setDocumentData(result);
    };
    fetchDocuments();
    return () => {
      URL.revokeObjectURL(objectURL);
    };
  }, []);

  useEffect(() => {
    if (task?.data?.length > 0) {
      setIdTache(task.data.find(t => t.tac_key.includes(props.selectedDocRow.rid))?.tac_id);
    }
  }, [props.selectedDocRow.rid, task]);

  useEffect(() => {
    if (taskPlanif?.data) {
      setCurrentTaskPlanif(taskPlanif.data.filter(t => t.tacdtl_statut !== completee));
    }
  }, [taskPlanif]);

  const handleSubmit = async () => {
    switch (document.activeElement.getAttribute("id")) {
      case "corrections":
        if (window.confirm('Voulez-vous vraiment terminer la tâche?')) {
          let taskPlanifData = structuredClone(currentTaskPlanif);
          for (let d of taskPlanifData) {
            d.tacdtl_statut = enAttente;
            await updateTachePlanif(d);
          }
          let changeAuthorTask = taskUser.data.filter(d => d.tacusr_statut === enCours).length === 1;
          let tacheUsager = { ...taskCurrentUser.data[0], tacusr_statut: enAttente };
          await updateTacheUsager(tacheUsager);
          if (changeAuthorTask) {
            let userTask = taskUser.data.find(t => t.usr_cd === data?.data?.find(d => d.docm_descr === 'usr_cd').docm_val);
            if (userTask) {
              let tacheAuthor = { ...taskUser.data.find(t => t.usr_cd === data?.data?.find(d => d.docm_descr === 'usr_cd').docm_val), tacusr_statut: enCours, tacusr_active: true };
              await updateTacheUsager(tacheAuthor);
            }
            else {
              await addTacheUsager({
                tac_id: idTache,
                usr_cd: task.data.find(t => t.tac_id === idTache).usr_cd_crea,
                tacusr_note: "",
                tacusr_statut: enCours,
                tacusr_active: true,
                tacusr_dttime: new Date()
              });
            }
          }
          navigate(`${location.pathname}${location.search.split('document=')[0]}`);
          props.toggleDialog();
        }
        break;
      case "completee":
        if (window.confirm('Voulez-vous vraiment terminer la tâche?')) {
          let tacheUsager = { ...taskCurrentUser.data[0], tacusr_statut: completee, tacusr_active: false };
          await updateTacheUsager(tacheUsager);
          navigate(`${location.pathname}${location.search.split('document=')[0]}`);
          props.toggleDialog();
        }
        break;
      case "confirmer":
        if (window.confirm('Voulez-vous confirmer la prise en charge de la mise à jour du document?')) {
          navigate(`${location.pathname}${location.search.split('document=')[0]}`);
          props.toggleDialog();
        }
        break;
      default: break;
    }
  };

  const getModalResume = () => {
    let groupBy = _.groupBy(currentTaskPlanif, t => t.usr_cd);
    return isAcheteur ? <Label><b>{`Vous avez un média en attente d'approbation. La date requise est le ${dateTextFormat(new Date(data.data.find(d => d.docm_descr === 'DocDtLimite').docm_val))}`}</b></Label> : <><Label style={{ marginBottom: '2vh' }}><b>Corrections à effectuer:</b></Label>
      <div style={{ display: 'grid', columnGap: '1rem', rowGap: '1rem', gridAutoFlow: 'dense', gridTemplateColumns: 'auto 2fr', maxHeight: '50vh', overflowY: 'auto', color: '#212529' }}>
        {Object.keys(groupBy).map((e, i) =>
          <Fragment key={i}><div>{e}</div>
            <ul>
              {groupBy[e].map((tacheDtl, index) => <li key={index} style={{ maxWidth: '30vw', wordBreak: 'break-word', marginBottom: '1vh' }}>{tacheDtl.tacdtl_descr}</li>)}
            </ul></Fragment>
        )}
      </div>
    </>;
  };

  const updatePlanif = async (commentaire) => {
    let commentToSend = { ...rowToEdit, tacdtl_descr: commentaire };
    await updateTachePlanif(commentToSend);
  };

  const removePlanif = async (rid) => {
    await removeTachePlanif(rid);
  };

  const addComment = async (formProps) => {
    let commentaire = formProps.valueGetter("commentaire");
    if (commentaire) {
      await addTachePlanif({
        rid: 0,
        tac_id: idTache,
        usr_cd: user,
        tacdtl_descr: commentaire,
        tacdtl_statut: '',
      });
      formProps.onFormReset();
    }
  };

  const getFileViewer = (fileType) => {
    let src = window.URL.createObjectURL(objectURL);

    if (fileType.startsWith("image/")) {
      return <><img onClick={() => {
        window.open(src);
      }} width={720} height={480} alt='Document' src={src} style={{ cursor: 'pointer' }} /></>;
    }
    else if (fileType.startsWith("video/")) {
      return <>
        <video width={720} height={480} controls>
          <source src={src} type={fileType} />
          Votre navigateur ne supporte pas les vidéos.
        </video></>;
    }
    else if (fileType.startsWith("audio/")) {
      return <>
        <audio controls>
          <source src={src} type={fileType} />
          Votre navigateur ne supporte pas les audios.
        </audio>
      </>;
    }
    else if (fileType === "application/pdf") {
      var reader = new FileReader();
      reader.readAsDataURL(objectURL);
      reader.onloadend = function () {
        // @ts-ignore
        setBase64PDF(reader.result.split(',')[1]);
      };
      return <PDFViewer data={base64PDF} style={{ height: '80vh', width: '60vw' }} />;
    }
    else if (fileType === "application/zip" || fileType === "application/x-zip-compressed") {
      return <a href={src} download style={{ fontSize: '20px', margin: '10px' }}><u>Télécharger le fichier zip</u></a>;
    }
    else {
      return <p style={{ color: "black" }}><b>{`Il n'est pas possible de visualiser le document car son format n'est pas supporté!`}</b></p>;
    }
  };

  const getForm = () => {
    return isAcheteur ? <Form initialValues={{ commentaire: "" }} ignoreModified={true} render={(formProps) => (
      <FormElement>
        <fieldset className={'k-form-fieldset'}>
          {currentTaskPlanif.length > 0 ? <div style={{ display: 'grid', columnGap: '1rem', rowGap: '1rem', gridAutoFlow: 'dense', gridTemplateColumns: '2fr auto auto', maxHeight: '50vh', overflowY: 'auto', alignItems: 'center' }}>{currentTaskPlanif.map((e, i) => {
            return <Fragment key={i}><span style={{ maxWidth: '30vw', }}>{e.tacdtl_descr}</span><Button icon='edit' type="button" className="blueButton" onClick={() => { setRowToEdit(e); }}></Button>
              <Button icon='trash' className="redButton" type='button' onClick={() => { removePlanif(e.rid); }}></Button></Fragment>;
          })}</div> : <div style={{ textAlign: 'center' }}><span><b>{`Vous n'avez pas ajouté de commentaires jusqu'à maintenant!`}</b></span></div>}
          <div style={{ marginTop: '3vh', display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Field
              id={'commentaire'}
              name={'commentaire'}
              label={'Commentaire'}
              optional={true}
              visited="false"
              onClick={() => addComment(formProps)}
              disabledButton={!formProps.valueGetter("commentaire")}
              component={FormTextAreaWithButton} />
          </div>
          <div className="k-form-buttons" style={{ display: 'flex', justifyContent: 'end', alignItems: 'end' }}>
            <Button className={currentTaskPlanif.length > 0 ? "redButton" : "blueButton"} type='button' onClick={handleSubmit} id={currentTaskPlanif.length > 0 ? 'corrections' : 'completee'}>{currentTaskPlanif.length > 0 ? "Soumettre les corrections" : "Approuver"}</Button>
          </div>
        </fieldset>
      </FormElement >)
    }
    /> : <Form initialValues={{ commentaire: "" }} ignoreModified={true} render={() => (
      < FormElement >
        <fieldset className={'k-form-fieldset'}>
          <FieldWrapper className='k-d-flex k-flex-column k-justify-content-around'>
            <div>
              <div className="k-form-buttons k-align-self-end">
                <Button className="blueButton" type='button' id="confirmer" onClick={handleSubmit}>Confirmer</Button>
              </div>
            </div>
          </FieldWrapper>
        </fieldset>
      </FormElement >)}
    />;
  };

  return (
    <>
      <CustomModal
        title={isAcheteur ? "Document à approuver" : "Demande de correction du document"}
        width={"auto"}
        onClose={props.toggleDialog}
        closeIcon={false}
        body={<>
          {(isLoading || !documentData) && (<LoaderContainer />)}
          {!isLoading && currentTaskPlanif && data.data && documentData && (<><div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1vh' }}>
            <h3 >{props.selectedDocRow.nom}</h3>
          </div><GridLayout style={{ overflowX: "auto" }} rows={[{ height: "auto" }, { height: "auto" }]} cols={[{ width: "auto" }, { width: "auto" }]} gap={{
            rows: "5px",
            cols: "20px"
          }}>
              <GridLayoutItem row={1} col={1} rowSpan={2} style={{ display: 'flex', alignItems: 'center' }}>
                {getFileViewer(documentData.headers["content-type"])}
              </GridLayoutItem>
              <GridLayoutItem row={1} col={2}>
                {getModalResume()}
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                {getForm()}
              </GridLayoutItem>
            </GridLayout></>)}
          {isLoading && <LoaderContainer style={{ height: '100px' }} />}</>}
      ></CustomModal>
      {rowToEdit && (<CustomModal title="Modifier le commentaire" width="auto" onClose={() => setRowToEdit(undefined)} body={<><Form ignoreModified={true} initialValues={{ commentaire: rowToEdit.tacdtl_descr }} render={(formProps) => (
        <><FormElement>
          <fieldset className={'k-form-fieldset'}>
            <div style={{ marginTop: '3vh', justifyContent: 'center', width: '100%' }}>
              <Field
                id={'commentaire'}
                name={'commentaire'}
                label={'Commentaire'}
                optional={true}
                visited="false"
                rows={4}
                component={FormTextArea} />
            </div>
          </fieldset>
        </FormElement>
          <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '3vh' }}>
            <Button onClick={() => { updatePlanif(formProps.valueGetter('commentaire')); setRowToEdit(undefined); }} className="blueButton">
              Enregistrer
            </Button>
            <Button onClick={() => { setRowToEdit(undefined); }} className="blueButton">
              Annuler
            </Button>
          </div>
        </>)
      }
      /></>}></CustomModal>)}
    </>
  );
}

ModifyFileModal.propTypes = {
  selectedDocRow: PropTypes.shape({
    Nom: PropTypes.any,
    nom: PropTypes.any,
    path: PropTypes.string,
    rid: PropTypes.any
  }),
  toggleDialog: PropTypes.func
};
